/* Edge state uses the actual scrollport, including drawer and Editor resizes.
 * Mouse dragging is provided by pebble-tabs.js through data-pebble-track.
 * One custom element per section keeps observers scoped and cleans up on reload.
 */
if (!customElements.get('pebble-flex-carousel')) {
  customElements.define('pebble-flex-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pebble-track]');
      if (!this.track) return;
      this.abort = new AbortController();
      this.sync = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offset = Math.abs(this.track.scrollLeft);
        this.track.parentElement.dataset.start = String(offset <= 1);
        this.track.parentElement.dataset.end = String(offset >= max - 1);
        this.track.toggleAttribute('data-pebble-draggable', max > 1);
        this.toggleAttribute('data-overflow', max > 1);
        this.querySelectorAll('[data-flex-step]').forEach((button) => {
          button.disabled = Number(button.dataset.flexStep) < 0 ? offset <= 1 : offset >= max - 1;
        });
      };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-flex-step]');
        if (!button || button.disabled) return;
        const cards = this.track.children;
        const pitch = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : this.track.clientWidth;
        this.track.scrollBy({ left: pitch * Number(button.dataset.flexStep), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.abort.signal });
      this.track.addEventListener('scroll', this.sync, { passive: true, signal: this.abort.signal });
      this.addEventListener('shopify:block:select', (event) => {
        event.target.closest('.pebble-flex-carousel__card')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }, { signal: this.abort.signal });
      this.resize = new ResizeObserver(this.sync);
      this.resize.observe(this.track);
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}
